if (!customElements.get('product-media')) {
  class ProductMedia extends HTMLElement {
    constructor() {
      super();

      this.lastActiveBreakpoint = '';
      this.swiperInitialized = false;

      this.selectors = {
        header: 'sticky-header',
        slider: '[data-slider]',
        thumbs: '[data-thumbs]',
        mediaItem: '[data-media-item]',
        mediaColor: 'data-media-color',
        thumbnail: '[data-thumbnail]',
        pagination: '[data-pagination]'
      };
      this.filterMediaBy = this.dataset.galleryFilter;

      this.breakpoints = { mobile: 320, tablet: 768, desktop: 991, desktop_large: 1440 };

      this.selectedMediaIndex = Number(
        this.querySelector(this.selectors.slider)?.querySelector('[data-selected]')?.dataset.index
      ) || 0;

      const paginationEl = this.querySelector(this.selectors.pagination);
      this.paginationDesktop = paginationEl ? { el: paginationEl, clickable: true, type: paginationEl.dataset.paginationType } : false;
      this.paginationMobile = paginationEl ? { el: paginationEl, clickable: true, type: paginationEl.dataset.paginationTypeMobile } : false;

      this.settings = {
        elements: {
          slider: this.querySelector(this.selectors.slider),
          thumbs: this.querySelector(this.selectors.thumbs)
        },
        instances: { slider: null, thumbs: null },
        options: {
          slider: {
            slidesPerView: 'auto',
            initialSlide: this.selectedMediaIndex,
            watchOverflow: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            pagination: this.paginationMobile,
            navigation: { prevEl: '[data-arrow-prev]', nextEl: '[data-arrow-next]' },
            autoHeight: this.hasAttribute('data-slider-autoheight'),
            breakpoints: { [this.breakpoints.desktop]: { allowTouchMove: false, pagination: this.paginationDesktop } }
          },
          thumbs: {
            initialSlide: this.selectedMediaIndex,
            spaceBetween: 8,
            slidesPerView: this.getThumbsPerView(),
            watchOverflow: true,
            watchSlidesProgress: true,
            setWrapperSize: true,
            navigation: { nextEl: '[data-thumbs-next]', prevEl: '[data-thumbs-prev]' },
            direction: 'horizontal',
            breakpoints: {
              [this.breakpoints.desktop]: { slidesPerView: 'auto', direction: this.hasAttribute('data-thumbs-layout') ? 'vertical' : 'horizontal' },
              [this.breakpoints.tablet]: { slidesPerView: 9 },
              [this.breakpoints.mobile]: { slidesPerView: this.getThumbsPerView(true) }
            }
          }
        }
      };
    }

    connectedCallback() {
      this.setThumbsHeight();
      requestAnimationFrame(() => this.init());

      window.addEventListener('resize', debounce(() => {
        this.setThumbsHeight();
        this.initSliders();
      }, 300));
    }

    init() {
      this.initSliders();
    }

    isMobileBreakpoint() {
      return window.innerWidth <= this.breakpoints.desktop;
    }

    getThumbsPerView(isMobile = false) {
      const useAspectRatio = this.hasAttribute('data-slider-autoheight');
      const useLayoutBottom = !this.hasAttribute('data-thumbs-layout');
      if (useAspectRatio) return 'auto';
      if (useLayoutBottom) return isMobile ? 5 : 9.26;
      return 5;
    }

    initSliders() {
      const isMobile = this.isMobileBreakpoint();
      const disabledOnDesktop = this.hasAttribute('data-slider-desktop-disabled');

      if ((isMobile && this.lastActiveBreakpoint === 'desktop') ||
          (!isMobile && this.lastActiveBreakpoint === 'mobile') ||
          (disabledOnDesktop && !isMobile)) {
        this.destroySwiper();
      }

      if (!this.swiperInitialized && (!disabledOnDesktop || isMobile)) {
        this.initSwiper();
      }

      this.lastActiveBreakpoint = isMobile ? 'mobile' : 'desktop';
    }

    initSwiper() {
      this.swiperInitialized = true;

      const thumbsEl = this.settings.elements.thumbs;
      if (thumbsEl) {
        this.settings.instances.thumbs = new Swiper(thumbsEl, this.settings.options.thumbs);
        this.settings.options.slider.thumbs = { swiper: this.settings.instances.thumbs };
      }

      const sliderEl = this.settings.elements.slider;
      this.settings.instances.slider = new Swiper(sliderEl, this.settings.options.slider);

      // Sync thumbs & slider
      if (thumbsEl) {
        this.settings.instances.slider.on('slideChangeTransitionStart', () => {
          this.settings.instances.thumbs.slideTo(this.settings.instances.slider.activeIndex);
        });
      }

      this.settings.instances.slider.on('slideChange', () => window.pauseAllMedia?.());
      this.settings.instances.slider.on('init', () => this.loadActiveVideo());
      this.settings.instances.slider.on('slideChangeTransitionEnd', () => this.loadActiveVideo());

      this.loadActiveVideo();
    }

    destroySwiper() {
      this.settings.instances.slider?.destroy();
      this.settings.instances.thumbs?.destroy();
      this.swiperInitialized = false;
    }

    loadActiveVideo() {
      const activeSlide = this.settings.elements.slider.querySelector('.swiper-slide-active');
      if (!activeSlide) return;
      
      // Pause only videos inside THIS component
      this.querySelectorAll('video').forEach(video => {
        if (!video.closest('.swiper-slide-active')) {
          if (!video.paused) video.pause();
        }
      });

      // Play active video safely
      const activeVideo = activeSlide.querySelector('video');

      if (activeVideo) {
        activeVideo.muted = true;
        activeVideo.play?.().catch(() => {});
      }

      
    }

    setActiveMedia(id) {
      const mediaFound = Array.from(this.querySelectorAll(this.selectors.mediaItem)).find(
        media => Number(media.dataset.mediaId) === id
      );
      if (!mediaFound) return;

      if (!this.settings.instances.slider || this.settings.instances.slider.destroyed) {
        const headerHeight = document.querySelector(this.selectors.header)?.offsetHeight || 0;
        window.scroll({ top: mediaFound.getBoundingClientRect().top + window.scrollY - headerHeight, behavior: 'smooth' });
        return;
      }

      this.settings.instances.slider.slideTo(Number(mediaFound.dataset.index));
    }

     filterMedia({ name, value }) {
  
      if (name !== this.filterMediaBy) return;

      const filteredMedia = this.querySelectorAll(
        `${this.selectors.mediaItem}[${this.selectors.mediaColor}="${value}"], 
         ${this.selectors.thumbnail}[${this.selectors.mediaColor}="${value}"]`
      );

   
      const hasFilteredMedia = filteredMedia.length !== 0;
 
      this.querySelectorAll(
        `${this.selectors.mediaItem}, ${this.selectors.thumbnail}`
      ).forEach(media => {
        if (!hasFilteredMedia) {
          media.classList.add('swiper-slide');
          media.classList.remove('hidden');
        } else {
          media.classList.remove('swiper-slide');
          media.classList.add('hidden');
        }
      });

      const inactiveSliderInstance =
        !this.settings.instances.slider ||
        this.settings.instances.slider?.destroyed;

      if (!hasFilteredMedia && !inactiveSliderInstance) {
        this.settings.instances.slider.update();
        this.settings.instances.thumbs?.update();
        return;
      }

      this.querySelectorAll(
        `${this.selectors.mediaItem}[${this.selectors.mediaColor}="${value}"], ${this.selectors.thumbnail}[${this.selectors.mediaColor}="${value}"]`
      ).forEach(media => {
        media.classList.add('swiper-slide');
        media.classList.remove('hidden');
      });

      if (inactiveSliderInstance) return;

      this.settings.instances.slider.update();
      this.settings.instances.thumbs?.update();
    }

    setThumbsHeight() {
      const thumbs = this.querySelector(this.selectors.thumbs)?.parentElement;
      if (!thumbs) return;
      const slider = this.querySelector(this.selectors.slider);
      thumbs.style.maxHeight = this.hasAttribute('data-thumbs-layout') && window.innerWidth > this.breakpoints.desktop
        ? `${slider.clientHeight}px`
        : '';
    }
  }

  customElements.define('product-media', ProductMedia);
}